import React from 'react';

import s from './Stats.module.scss';

type Props = {
  label?: React.ReactNode;
  children?: React.ReactNode;
};

export const Item = ({ label, children }: Props) => {
  return (
    <figure className={s.item}>
      <div className={s.item__number}>{children}</div>
      <figcaption className={s.item__caption}>{label}</figcaption>
    </figure>
  );
};
